module.exports = __webpack_public_path__ + "img/hnor.e3d8d2d2.png";